/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PaletteRegular from './palette-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PaletteRegular {...validProps} />;
}

SvgComponent.iconName = 'paletteRegular';

export const PaletteRegularIcon = svgIconWrapper(SvgComponent);
